// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Uha-z","beautyGrouping":"Vha-z","beautySwatches":"Wha-z","swatches":"Xha-z"};